var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 12.1875C1.25918 12.1875 0 13.4473 0 15C0 16.5527 1.25918 17.8125 2.8125 17.8125C4.36582 17.8125 5.625 16.5527 5.625 15C5.625 13.4473 4.36582 12.1875 2.8125 12.1875ZM2.8125 21.5625C1.25918 21.5625 0 22.8223 0 24.375C0 25.9277 1.25918 27.1875 2.8125 27.1875C4.36582 27.1875 5.625 25.9277 5.625 24.375C5.625 22.8223 4.36582 21.5625 2.8125 21.5625ZM2.8125 2.8125C1.25918 2.8125 0 4.07168 0 5.625C0 7.17832 1.25918 8.4375 2.8125 8.4375C4.36582 8.4375 5.625 7.17773 5.625 5.625C5.625 4.07227 4.36582 2.8125 2.8125 2.8125ZM11.25 7.5H28.125C29.1604 7.5 30 6.66035 30 5.67773C30 4.69512 29.1621 3.75 28.125 3.75H11.25C10.2129 3.75 9.375 4.58965 9.375 5.57227C9.375 6.55488 10.2129 7.5 11.25 7.5ZM28.125 13.125H11.25C10.2129 13.125 9.375 13.9629 9.375 15C9.375 16.0371 10.2146 16.875 11.25 16.875H28.125C29.1604 16.875 30 16.0354 30 15C30 13.9646 29.1621 13.125 28.125 13.125ZM28.125 22.5H11.25C10.2146 22.5 9.375 23.3396 9.375 24.375C9.375 25.4104 10.2146 26.25 11.25 26.25H28.125C29.1604 26.25 30 25.4104 30 24.375C30 23.3396 29.1621 22.5 28.125 22.5Z",
    fill: "#57DBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubList);
export default __webpack_public_path__ + "static/media/subList.f95ec983eff879442d8d1e9ca16266e7.svg";
export { ForwardRef as ReactComponent };